import { type IStoreState } from "@/vue/planning/store/state/state"
import { WiypResponse } from "@/types/responses"

export default {
	wiypCall: (state: IStoreState): Record<string, Record<string, WiypResponse>> => {
		return state.wiypCall;
	},
	getWiypCallByPackageCode: (state: IStoreState) => (packageCode: string): Record<string, WiypResponse> | undefined => {
		return state.wiypCall[packageCode];
	},
	getWiypCallByPackageCodeAndId: (state: IStoreState) => (packageCode: string, packageId: string): WiypResponse | undefined => {
		return state.wiypCall[packageCode]?.[packageId];
	},
}

